import {
	DriftClient,
	getUserStatsAccountPublicKey,
	getFuelOverflowAccountPublicKey,
	UserStatsAccount,
	UserAccount,
	FuelOverflowAccount,
} from '@drift-labs/sdk';
import { PublicKey } from '@solana/web3.js';

export const fetchUserStats = async (
	driftClient: DriftClient,
	vaultPubkey: PublicKey
) => {
	const userStatsPubkey = getUserStatsAccountPublicKey(
		driftClient.program.programId,
		vaultPubkey
	);
	const userStats = await driftClient.program.account.userStats.fetch(
		userStatsPubkey
	);

	return userStats as UserStatsAccount;
};

export const fetchDriftUserAccount = async (
	driftClient: DriftClient,
	vaultDriftUserPubkey: PublicKey
) => {
	const driftUserAccount = await driftClient.program.account.user.fetch(
		vaultDriftUserPubkey
	);

	return driftUserAccount as UserAccount;
};

export const fetchFuelOverflowAccount = async (
	driftClient: DriftClient,
	vaultPubkey: PublicKey
) => {
	try {
		const vaultFuelOverflowAccount =
			await driftClient.program.account.fuelOverflow.fetch(
				getFuelOverflowAccountPublicKey(
					driftClient.program.programId,
					vaultPubkey
				)
			);

		return vaultFuelOverflowAccount as FuelOverflowAccount;
	} catch {
		return undefined;
	}
};
